var _rect, _rect2, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnabledVirtualcard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 153,
    viewBox: "0 0 243 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.382075,
    y: 0.382075,
    width: 242.236,
    height: 152.236,
    rx: 8.78774,
    fill: "#5E85FE",
    stroke: "#5E85FE",
    strokeWidth: 0.764151
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_727_9995",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 243,
    height: 153
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.382075,
    y: 0.382075,
    width: 242.236,
    height: 152.236,
    rx: 8.78774,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.764151
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_727_9995)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_9995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.804 110.004C203.568 110.004 204.998 108.558 204.998 106.775C204.998 104.991 203.568 103.545 201.804 103.545C200.04 103.545 198.61 104.991 198.61 106.775C198.61 108.558 200.04 110.004 201.804 110.004Z",
    fill: "#FFF6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.321 114.571C208.085 114.571 209.515 113.125 209.515 111.342C209.515 109.558 208.085 108.112 206.321 108.112C204.558 108.112 203.128 109.558 203.128 111.342C203.128 113.125 204.558 114.571 206.321 114.571Z",
    fill: "#FFF6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.838 110.004C212.601 110.004 214.031 108.558 214.031 106.775C214.031 104.991 212.601 103.545 210.838 103.545C209.074 103.545 207.644 104.991 207.644 106.775C207.644 108.558 209.074 110.004 210.838 110.004Z",
    fill: "#FFF6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.838 128.273C212.601 128.273 214.031 126.827 214.031 125.043C214.031 123.26 212.601 121.814 210.838 121.814C209.074 121.814 207.644 123.26 207.644 125.043C207.644 126.827 209.074 128.273 210.838 128.273Z",
    fill: "#FFF6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.321 123.706C208.085 123.706 209.515 122.26 209.515 120.477C209.515 118.693 208.085 117.247 206.321 117.247C204.558 117.247 203.128 118.693 203.128 120.477C203.128 122.26 204.558 123.706 206.321 123.706Z",
    fill: "#FFF6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.804 128.273C203.568 128.273 204.998 126.827 204.998 125.043C204.998 123.26 203.568 121.814 201.804 121.814C200.04 121.814 198.61 123.26 198.61 125.043C198.61 126.827 200.04 128.273 201.804 128.273Z",
    fill: "#FFF6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.354 114.571C217.117 114.571 218.547 113.125 218.547 111.342C218.547 109.558 217.117 108.112 215.354 108.112C213.59 108.112 212.16 109.558 212.16 111.342C212.16 113.125 213.59 114.571 215.354 114.571Z",
    fill: "#FFF6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.838 119.139C212.601 119.139 214.031 117.693 214.031 115.91C214.031 114.126 212.601 112.68 210.838 112.68C209.074 112.68 207.644 114.126 207.644 115.91C207.644 117.693 209.074 119.139 210.838 119.139Z",
    fill: "#FFF6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.354 123.706C217.117 123.706 218.547 122.26 218.547 120.477C218.547 118.693 217.117 117.247 215.354 117.247C213.59 117.247 212.16 118.693 212.16 120.477C212.16 122.26 213.59 123.706 215.354 123.706Z",
    fill: "#FFF6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.288 123.706C199.052 123.706 200.482 122.26 200.482 120.477C200.482 118.693 199.052 117.247 197.288 117.247C195.524 117.247 194.094 118.693 194.094 120.477C194.094 122.26 195.524 123.706 197.288 123.706Z",
    fill: "#FFF6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.804 119.139C203.568 119.139 204.998 117.693 204.998 115.91C204.998 114.126 203.568 112.68 201.804 112.68C200.04 112.68 198.61 114.126 198.61 115.91C198.61 117.693 200.04 119.139 201.804 119.139Z",
    fill: "#FFF6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.288 114.571C199.052 114.571 200.482 113.125 200.482 111.342C200.482 109.558 199.052 108.112 197.288 108.112C195.524 108.112 194.094 109.558 194.094 111.342C194.094 113.125 195.524 114.571 197.288 114.571Z",
    fill: "#FFF6E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_9995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.4528,
    height: 24.7273,
    fill: "white",
    transform: "translate(194.094 103.545)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnabledVirtualcard);
export default __webpack_public_path__ + "static/media/enabled-virtualcard.6b51ea12e6d87bcbaf2661e8aec27549.svg";
export { ForwardRef as ReactComponent };